import React from 'react';
import {
  Content,
  Container,
  EventInformation,
  DataContainer,
  ImageContainer,
  GoalInformation,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Image, Typography} from '@fupa/fupa-uikit';
import {FlexContainer} from 'app/styles/content';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {Person, Alarm} from '@mui/icons-material';

const TickerWrapper = styled(FlexContainer)`
  padding-top: 0.5rem;
`;

const TickerAuthorAssigned = ({author}) => {
  const authorImage = author.image ? (
    <Image entity='user' src={author.image} ratio='1:1' width={64} height={64} circle={true} />
  ) : (
    <Person style={{color: COLORS.lightGrey, fontSize: 64}} />
  );
  const authorName =
    author.lastName && author.firstName
      ? `${author.firstName} ${author.lastName}`
      : author.lastName
      ? author.lastName
      : 'Anonym';

  return (
    <Content>
      <Container>
        <EventInformation customBgColor={COLORS.lightBlue}>
          <Alarm style={{color: COLORS.white, fontSize: 20}} />
        </EventInformation>
        <DataContainer>
          <Typography variant='body2'>
            Der Liveticker ist gesichert! 🙌
            <br />
            Alle Infos und Geschehnisse zum Spiel gibt's live von:
          </Typography>
          <TickerWrapper>
            <ImageContainer>{authorImage}</ImageContainer>
            <GoalInformation>
              <Typography variant='body1'>{authorName}</Typography>
              <Typography variant='body2'>Liveticker</Typography>
            </GoalInformation>
          </TickerWrapper>
        </DataContainer>
      </Container>
    </Content>
  );
};

TickerAuthorAssigned.propTypes = {
  author: PropTypes.object.isRequired,
};

export {TickerAuthorAssigned};
